import {createContext, useContext, useState} from "react";
import {useTable} from "hooks/useTable";
import PartnerApi from "api/partner.api";
import {
    servicePartnerDestroy,
    servicePartnerOrder,
    servicePartnerSave,
    servicePartnerUpdateAction
} from "services/partner.service";

const PartnerContext = createContext();

export const PartnerProvider = ({children}) => {

    const translateKey = 'crm.Partner';
    const permission = 'partner';
    const [tableRow, setTableRow] = useState({});
    const [filter, setFilter] = useState({});
    const [modal, setModal] = useState({
        form: false
    });

    const {dataSource, setDataSource, loading: tableLoading, fetchDataSource, handleQuery, query} = useTable(PartnerApi.getIndex);

    const handleFilter = (newFilter) => {
        setFilter(f => ({
            ...f,
            ...newFilter
        }))
    }

    const handleModal = (name, action, data = {}) => {
        setModal(m => ({
            ...m,
            [name]: action
        }))
        setTableRow(data);
    }

    const handleAction = async (id, action = 'is_active') => {
        const res = await servicePartnerUpdateAction(id, action);
        if (res) await fetchDataSource();
    }

    const handleDelete = async (id) => {
        const res = await servicePartnerDestroy(id);
        if (res) await fetchDataSource();
    }

    const handleSave = async (form) => {
        const res = await servicePartnerSave(form)
        if (res) {
            await fetchDataSource();
            return true;
        }
        return false;
    }

    const handleOrderChange = async (value, id) => {
        const index = dataSource.data.findIndex(i => i.id === id);
        dataSource.data[index].order = value;
        setDataSource(d => ({
            ...d,
            data: [...dataSource.data]
        }));
    }

    const handleOrderSave = async (value, id) => {
        if (value && id) {
            const res = await servicePartnerOrder(id, {order: value});
            if (res) {
                await fetchDataSource()
            }
        }
    }

    const values = {
        translateKey,
        modal,
        permission,
        filter,
        tableRow,
        dataSource,
        query,
        tableLoading,
        fetchDataSource,
        handleQuery,
        handleModal,
        handleFilter,
        handleAction,
        handleDelete,
        handleSave,
        handleOrderChange,
        handleOrderSave
    };

    return <PartnerContext.Provider value={values}>
        {children}
    </PartnerContext.Provider>
}

export const usePartnerContext = () => useContext(PartnerContext);
